export const FlEvent = {
  Deploy: "deploy",
  Hit: "hit",
  Promote: "promote",
  Skill: "skill",
  SkillWave: "skill_wave",
  Death: "death",
  BaseHit: "base_hit",
  Ability: "ability",
  Result: "result",
} as const;

export type FlEventKind = (typeof FlEvent)[keyof typeof FlEvent];

export type FlSimEvent =
  | {
      kind: typeof FlEvent.Deploy;
      team: 0 | 1;
      x: number;
      y: number;
      unitId: number;
      role: string;
      tier: 1 | 2 | 3;
    }
  | {
      kind: typeof FlEvent.Hit;
      attackerId: number;
      targetId: number;
      x: number;
      y: number;
      damage: number;
      role: string;
      x0: number;
      y0: number;
      x1: number;
      y1: number;
    }
  | {
      kind: typeof FlEvent.Promote;
      unitId: number;
      fromTier: 1 | 2;
      toTier: 2 | 3;
      role: string;
      x: number;
      y: number;
      kills: number;
      level: number;
    }
  | {
      kind: typeof FlEvent.Skill;
      skillId: string;
      team: 0 | 1;
      x: number;
      y: number;
      targetId?: number;
      heal?: number;
      damage?: number;
    }
  | {
      kind: typeof FlEvent.SkillWave;
      skillId: string;
      team: 0 | 1;
      ring: number;
      cells: { col: number; row: number; x: number; y: number }[];
      hits: {
        unitId: number;
        x: number;
        y: number;
        heal?: number;
        damage?: number;
      }[];
    }
  | { kind: typeof FlEvent.Death; unitId: number; x: number; y: number }
  | {
      kind: typeof FlEvent.BaseHit;
      team: 0 | 1;
      attackerId: number;
      damage: number;
      x: number;
      y: number;
      role: string;
      x0: number;
      y0: number;
      x1: number;
      y1: number;
    }
  | {
      kind: typeof FlEvent.Ability;
      abilityId: string;
      casterId: number;
      x: number;
      y: number;
      targetIds?: number[];
      damage?: number;
    }
  | { kind: typeof FlEvent.Result; result: "won" | "lost" | "draw" };
